// @flow

import { graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeleteVendorItemPriceMutation($input: DeleteVendorItemPriceInput!) {
    deleteVendorItemPrice(input: $input) {
      success
    }
  }
`;

export default {
  commit: (options: *) => {
    const deletedItemPriceId = options.variables.input.id;
    
    return createRelayMutation(mutation, {
      ...options,
      updater: (store) => {
        // Get the deleted item price to find its vendor
        const deletedRecord = store.get(deletedItemPriceId);
        
        if (deletedRecord) {
          const vendor = deletedRecord.getLinkedRecord('vendor');
          
          if (vendor) {
            // Get existing itemPrices record
            const itemPrices = vendor.getLinkedRecord('itemPrices');
            
            if (itemPrices) {
              // Get existing edges
              const edges = itemPrices.getLinkedRecords('edges') || [];
              
              // Filter out the deleted edge
              const updatedEdges = edges.filter(edge => {
                if (!edge) return false;
                const node = edge.getLinkedRecord('node');
                if (!node) return false;
                return node.getValue('id') !== deletedItemPriceId;
              });
              
              // Update the edges array
              itemPrices.setLinkedRecords(updatedEdges, 'edges');
            }
          }
        }
        
        // Also remove the record itself from the store
        store.delete(deletedItemPriceId);
      },
    });
  },
};
